import React, { useEffect, useState } from "react";
import useTranslation from "../util/useTranslate";
import { Table, Button } from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";
import Navbar from "Components/Navbar";
import ParallaxBackground from "Components/ParallaxBackground";
import CreateGameModal from "Components/CreateGameModal";
import JoinGameModal from "Components/JoinGameModal";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getPlayerSessionsList } from "util/supabase";

const Lobby = () => {
  const [serverSessionsList, setServerSessionsList] = useState([]);
  const [showCreateGameModal, setShowCreateGameModal] = useState(false);
  const [joinGameModalSessionId, setJoinGameModalSessionId] = useState(null);
  const navigate = useNavigate();
  const translate = useTranslation();

  const { sessionsList, playerId, currentPlayerState, updateState } = useOutletContext();

  useEffect(() => {
    getPlayerSessionsList(playerId).then((list) => {
      setServerSessionsList(list);
    });
  }, [playerId]);

  useEffect(() => {
    if (currentPlayerState?.isHost) {
      updateState({ isHost: false, sessionId: null, gameName: null });
    }
  }, [currentPlayerState, updateState]);

  const rejoinGame = (sessionId) => {
     navigate(`/game/${sessionId}`);
  }
  
  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <div className="d-flex justify-content-between">
          <Button
            style={{ width: "auto" }}
            variant="success"
            onClick={() => setShowCreateGameModal(true)}
          >
            {translate("createGame")} <Plus />
          </Button>
        </div>

        <Table striped bordered className="mt-4">
          <thead>
            <tr>
              <th>{translate("name")}</th>
              <th>{translate("playerNumber")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {[...serverSessionsList, ...sessionsList].map(({ gameName, sessionId, playersNum, isStarted }) => (
              <tr key={sessionId}>
                <td>{gameName}</td>
                <td>{isStarted ? translate("inProgress") : `${playersNum}/4`}</td>
                <td width={200}>
                  <Button
                    variant="primary"
                    onClick={() => isStarted ? rejoinGame(sessionId) : setJoinGameModalSessionId(sessionId)}
                  >
                    {translate("joinGame")}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <ParallaxBackground
        src={"backgrounds/cardsBottom.png"}
        position={"bottom center"}
        size={"60vw"}
      />
      <CreateGameModal
        show={showCreateGameModal}
        onHide={() => setShowCreateGameModal(false)}
      />
      <JoinGameModal
        sessionId={joinGameModalSessionId}
        onHide={() => setJoinGameModalSessionId(null)}
      />
    </>
  );
};

export default Lobby;
